import { InjectionToken } from "@angular/core";
import { WalletPayablesPort } from "./wallet-payables.port";

export const WALLET_PAYABLES_PORT =
  new InjectionToken<WalletPayablesPort>("WALLET_PAYABLES_PORT");
